<script setup lang="ts">
import './assets/style.scss'
import { VIcons } from '@/shared/ui'
import { useAuth } from '@/entities/Auth'

const { user } = useAuth()
</script>

<template>
  <div class="w-admin-menu">
    <router-link class="w-admin-menu__link" to="/">
      <VIcons type="stack" />
      <p>{{ user?.object_group?.name || $t('itf.home') }}</p>
    </router-link>
  </div>
</template>
